export default '/static/frontend/ReachDigital/12gobiking/dist/assets/postnl-e90dca2a.png'